import React from 'react';

const FormikRadioGroupField = ({ field, form, label, options, ...rest }) => {
  return (
    <div>
      <label style={{ marginBottom: '20px' }}>{label}</label>
      <div role="group" aria-label={label}>
        {options.map((option) => (
          <label key={option.value} style={{ marginRight: '10px' }}>
            <input
              type="radio"
              {...field}
              value={option.value}
              checked={field.value === option.value}
              {...rest}
            />
            <span style={{ marginLeft: '4px' }}> {option.label} </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default FormikRadioGroupField;
